import React from 'react';
import { Form } from 'react-bootstrap';

export default function BackButtonWidgetEditor({ item, onChange }) {
  const update = (field, val) => onChange?.({ ...item, [field]: val });

  return (
    <div className="mt-3">
      <Form.Group className="mb-3">
        <Form.Label>Button title</Form.Label>
        <Form.Control
          value={item.title || ''}
          onChange={(e) => update('title', e.target.value)}
          placeholder="e.g. Back"
        />
      </Form.Group>
      <p className="muted-hint mb-0">Always links to the parent page of wherever this widget is placed.</p>
    </div>
  );
}
